import { siteRoutingActionCreators } from '@app/routes/Development/Clients/Sites/View/modules/developmentSiteView'
import { notificationItemActionCreators } from '@app/store/modules/systemNotifications'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  SystemNotificationItem,
  ISystemNotificationItemProps,
} from '../components/SystemNotificationItem'

export default withRouter(
  connect((state, ownProps: ISystemNotificationItemProps) => ownProps, {
    ...notificationItemActionCreators,
    ...siteRoutingActionCreators,
  })(SystemNotificationItem),
)
